<template>
<transition name="modal">
	<div class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container-wrapper">
			<div class="modal-condcontainer">
				<div class="modal-window-tab-mark">
				</div>
				<div class="modal-close-button" @click="$emit('close')"><img alt="סגור" src="images/x.png" class="fillImg" /></div>
				<div class="modal-wndow-content">
					<div class="modal-wndow-content-title">
						<h3>תנאי סף להצטרפות להרכב רית'ם</h3></div>
					<div class="login-info" >
<p>
הפרמטרים המפורטים פה הם המינימום הנדרש - נשמח מאוד כמובן לראות הרבה יותר מזה, אבל אם אתם יחסית מתחילים - זה מה שאתם צריכים להיות מסוגלים לעשות:
</p>
<p>
<u>
שירה:
</u>
 פגיעה בצליל ומודעות לטעויות כשיש, ביצוע רתמי ברמה סבירה, יכולת הפקת צליל בעצמה מתאימה להרכב (חזקה יחסית) והכרת העבודה עם מיקרופון.
<br>
זמרים שרוצים לשיר בהרכב צריכים להיות בעלי ניסיון שירה משמעותי בהרכב רית'ם (תופים, גיטרות וכו') ו/או אחרי לימוד פיתוח קול לפחות במשך שנה שמכוון למקום הזה. 
<br>
הרשמת זמרים להרכב רית'ם תתבצע לאחר שיחת ייעוץ טלפונית עם המשרד בלבד.
</p>
<p>
<u>
גיטרה/קלידים/בס:
</u>
 הכרה בסיסית של הכל ותפעול שלו, יכולת לזהות ולנגן את כל האקורדים הבסיסיים בהפקת צליל סבירה, החזקת קצב והבנה קצבית סבירה, מודעות לטעויות.
</p>
<p>
<u>
תופים:
</u>
 החזקת קצב סבירה, התמצאות בסיסית והבנת מבנה של שיר, נגינה בבאלאנס סביר בסט ומודעות לטעויות.
</p>
<p>
<u>
כלי נשיפה:
</u>
 הפקת צליל מדויקת ובעצמה מתאימה להרכב, יכולת לקרוא תפקיד בסיסי/לשמוע תפקיד ולהוציא אותו משמיעה, מוסיקליות ומודעות לטעויות.
</p>
<p>
<u>
לכולם:
</u>
 אין הכרח לדעת תווים.
</p>
					</div>
				</div>
				<div class="modal-bottom-image"><img src="images/logo.png" alt="החצר" class="fillImg" /></div>
			</div>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
var APIbase = "https://yard-bands.herokuapp.com"
export default {
	components: {},
	props: ['userId','auditionType','adminContext'],
	created() {
	
	},
	data() {
		return {
			nameInput : "",
			instrumentInput : "כלי נגינה ראשי",
			emailInput : "",
			phoneInput : "",
			validationMessage : "",
			loginState: 0,
			refreshId:0
		}
	},
	watch: {
		
	},
	methods: {

	},

}
</script>



// WEBPACK FOOTER //
// Conditions.vue?351567bc